import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import axios from "axios";
import { localApi } from "utils/imgApi";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import CornerRibbon from "react-corner-ribbon";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import MenuItem from "@material-ui/core/MenuItem";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import { AiOutlineFolderView } from "react-icons/ai";
import Tooltip from "@material-ui/core/Tooltip";
import Edit from "@material-ui/icons/Edit";
import styles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";
import styDrop from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import styHoever from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";
import SweetAlert from "react-bootstrap-sweetalert";
import styleSweet from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";

import { credentials } from "utils/imgApi";

import {
  Favorite,
  FavoriteBorder,
  ChatBubbleOutline,
  Repeat,
  ShareOutlined,
  Phone,
  WhatsApp,
  Bookmark,
  BookmarkBorder,
  MoreHoriz,
  Send,
  Delete,
  Close,
} from "@material-ui/icons";

const useStyles = makeStyles(styles);
const useStyl = makeStyles(styDrop);
const useHoever = makeStyles(styHoever);
const useStyleSweet = makeStyles(styleSweet);

export default function ViewPosts(props) {
  const [posts, setPosts] = React.useState([]);
  const [ribbonColors, setRibbonColors] = useState({});

  const [alertType, alertTypeOps] = React.useState("");
  const [alertMsg, alertMsgOps] = React.useState("");
  const [submitted, setSubmitted] = React.useState(false);
  const [submitteds, setSubmitteds] = React.useState(false);
  const [submittedConfirm, setSubmittedConfirm] = React.useState(false);

  const classes = useStyles();
  const classe = useStyl();
  const classeHover = useHoever();
  const classSweet = useStyleSweet();
  const history = useHistory();

  const activeSession = sessionStorage.getItem("sessionData");

  const { state } = useLocation();

  const userObj = JSON.parse(sessionStorage.getItem("sessionData"));

  function convertToNextTenth(num) {
    return (Math.ceil(num * 10) / 10).toFixed(2);
  }

  async function getUsers() {
    const api = localApi + `/posts/list/byAdminId/${userObj && userObj.id}`;

    const result = await fetch(api, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });

    const getResult = await result.json();
    setPosts(getResult && getResult);

    // console.log(getResult);
  }

  useEffect(() => {
    getUsers();
  }, []);

  const hideAlert = () => {
    setSubmitted(false);
    window.location.reload(false);
  };

  const hideAlerts = () => {
    setSubmitteds(false);
    setSubmittedConfirm(false);
    window.location.reload(false);
  };

  /*
   * Main post card
   *
   * Margin is kept 0 because spacing is controlled
   * by the GridItem below.
   */
  const cardStyle = {
    width: "100%",
    height: "auto",
    margin: 0,
    padding: 0,
    borderRadius: 12,
    overflow: "hidden",
    backgroundColor: "#ffffff",
    boxShadow: "0 4px 14px rgba(0, 0, 0, 0.10)",
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
    marginBottom: 20,
  };

  const headerRowStyle = {
    display: "flex",
    alignItems: "center",
    minHeight: 65,
    padding: "12px 16px",
    background: "#fafafa",
    borderBottom: "1px solid #eeeeee",
    flexShrink: 0,
    boxSizing: "border-box",
  };

  const AvatarImage = ({ src, company }) => {
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
      setHasError(false);
    }, [src]);

    if (!src || hasError) {
      return <AvatarFallback company={company} />;
    }

    return (
      <img
        src={src}
        alt={company || "Company avatar"}
        title={company || "Company"}
        style={{
          width: 40,
          height: 40,
          minWidth: 40,
          borderRadius: "50%",
          marginRight: 12,
          objectFit: "cover",
          border: "1px solid #eeeeee",
        }}
        onError={() => setHasError(true)}
      />
    );
  };

  const AvatarFallback = ({ company, style }) => {
    return (
      <div
        aria-label={company || "Company avatar"}
        title={company || "Company"}
        style={{
          width: 40,
          height: 40,
          minWidth: 40,
          borderRadius: "50%",
          marginRight: 12,
          border: "1px solid #eeeeee",
          backgroundColor: "#e0e0e0",
          color: "#262626",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 14,
          fontWeight: 700,
          overflow: "hidden",
          ...style,
        }}
      >
        {getInitials(company)}
      </div>
    );
  };

  const getInitials = (company) => {
    if (!company || typeof company !== "string") {
      return "?";
    }

    const words = company.trim().split(/\s+/).filter(Boolean);

    if (words.length === 0) {
      return "?";
    }

    if (words.length === 1) {
      return words[0].substring(0, 2).toUpperCase();
    }

    return `${words[0].charAt(0)}${words[1].charAt(0)}`.toUpperCase();
  };

  const imageWrapperStyle = {
    position: "relative",
    height: 260,
    width: "100%",
    overflow: "hidden",
    background: "#f5f5f5",
    flexShrink: 0,
  };

  const imageStyle = {
    display: "block",
    width: "100%",
    height: "100%",
    objectFit: "cover",
  };

  const ribbonTopStyle = {
    position: "absolute",
    top: 12,
    left: "50%",
    transform: "translateX(-50%)",
    color: "#ffffff",
    padding: "6px 10px",
    borderRadius: 5,
    fontSize: 11,
    lineHeight: "14px",
    fontWeight: 700,
    whiteSpace: "nowrap",
    transition: "background 0.3s ease",
    zIndex: 2,
  };

  const ribbonBottomStyle = {
    position: "absolute",
    bottom: 12,
    left: 12,
    background: "rgba(218, 165, 32, 0.93)",
    color: "#111111",
    padding: "6px 14px",
    borderRadius: 5,
    fontSize: 12,
    lineHeight: "14px",
    fontWeight: 700,
    whiteSpace: "nowrap",
    zIndex: 2,
  };

  const ribbonCategoryStyle = {
    position: "absolute",
    top: "50%",
    right: 12,
    transform: "translateY(-50%)",
    background: "rgba(0, 0, 0, 0.55)",
    color: "#ffffff",
    padding: "6px 10px",
    borderRadius: 5,
    fontSize: 12,
    lineHeight: "14px",
    fontWeight: 700,
    textAlign: "center",
    whiteSpace: "nowrap",
    zIndex: 2,
  };

  const captionStyle = {
    color: "#262626",
    fontSize: 13,
    lineHeight: "19px",
  };

  const hashtagStyle = {
    color: "#505050",
    fontSize: 13,
    lineHeight: "18px",
    marginTop: 2,
  };

  const metaRowStyle = {
    display: "flex",
    alignItems: "center",
    marginTop: 3,
  };

  const handleImageLoad = (event, postId) => {
    try {
      const image = event.target;

      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");

      if (!context) {
        throw new Error("Canvas context is not available");
      }

      const sampleSize = 50;

      canvas.width = sampleSize;
      canvas.height = sampleSize;

      context.drawImage(image, 0, 0, sampleSize, sampleSize);

      const imageData = context.getImageData(0, 0, sampleSize, sampleSize);

      let redTotal = 0;
      let greenTotal = 0;
      let blueTotal = 0;
      let pixelCount = 0;

      for (let index = 0; index < imageData.data.length; index += 4) {
        const red = imageData.data[index];
        const green = imageData.data[index + 1];
        const blue = imageData.data[index + 2];
        const alpha = imageData.data[index + 3];

        if (alpha < 100) {
          continue;
        }

        if (red > 245 && green > 245 && blue > 245) {
          continue;
        }

        redTotal += red;
        greenTotal += green;
        blueTotal += blue;
        pixelCount += 1;
      }

      if (pixelCount === 0) {
        throw new Error("No usable image pixels");
      }

      const red = Math.round(redTotal / pixelCount);
      const green = Math.round(greenTotal / pixelCount);
      const blue = Math.round(blueTotal / pixelCount);

      setRibbonColors((previous) => ({
        ...previous,
        [postId]: `rgba(${red}, ${green}, ${blue}, 0.88)`,
      }));
    } catch (error) {
      setRibbonColors((previous) => ({
        ...previous,
        [postId]: "rgba(0, 0, 0, 0.55)",
      }));
    }
  };

  const actionsRowStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    minHeight: 52,
    padding: "8px 10px",
    flexShrink: 0,
  };

  const leftActionsStyle = {
    display: "flex",
    alignItems: "center",
    gap: 0,
    overflow: "hidden",
  };

  const actionWithValueStyle = {
    display: "flex",
    alignItems: "center",
    marginRight: 2,
  };

  const actionCountStyle = {
    color: "#444444",
    fontSize: 11,
    fontWeight: 600,
    marginLeft: -5,
    marginRight: 2,
    whiteSpace: "nowrap",
  };

  return (
    <div
      style={{
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      {/* <GridContainer
        justify="center"
        alignItems="center"
        style={{
          marginBottom: "5%",
        }}
      >
        <GridItem xs={12} sm={12} md={8}>
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon color="rose">
                <AiOutlineFolderView />
              </CardIcon>

              <h3 className={classes.cardIconTitle}>
                <small>View Posts</small>
              </h3>
            </CardHeader>

            <CardBody>
              <GridContainer>
                {submitted ? (
                  <SweetAlert
                    type={alertType}
                    style={{
                      display: "block",
                      marginTop: "-100px",
                    }}
                    title={alertMsg}
                    onConfirm={() => hideAlert()}
                    confirmBtnCssClass={
                      classSweet.button + " " + classSweet.success
                    }
                  />
                ) : null}

                {submitteds ? (
                  <SweetAlert
                    warning
                    style={{
                      display: "block",
                      marginTop: "100px",
                    }}
                    title="Are you sure?"
                    // onConfirm={handleConfirm}
                    onCancel={() => hideAlerts()}
                    confirmBtnCssClass={
                      classSweet.button + " " + classSweet.success
                    }
                    cancelBtnCssClass={
                      classSweet.button + " " + classSweet.danger
                    }
                    confirmBtnText="Yes, delete it!"
                    cancelBtnText="Cancel"
                    showCancel
                  />
                ) : null}

                {submittedConfirm ? (
                  <SweetAlert
                    success
                    style={{
                      display: "block",
                      marginTop: "100px",
                    }}
                    title="Deleted!"
                    onConfirm={() => hideAlerts()}
                    onCancel={() => hideAlerts()}
                    confirmBtnCssClass={
                      classSweet.button + " " + classSweet.success
                    }
                  >
                    Your imaginary posts has been deleted.
                  </SweetAlert>
                ) : null}
              </GridContainer>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer> */}

      {/* Posts Grid */}
      <GridContainer
        style={{
          marginLeft: 0,
          marginRight: 0,
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        {posts.map((post) => {
          const endDate = post.endDate ? new Date(post.endDate) : null;

          const isOfferActive =
            endDate && !Number.isNaN(endDate.getTime())
              ? endDate.getTime() >= Date.now()
              : false;

          const isReposted =
            typeof post.isReposted === "boolean"
              ? post.isReposted
              : Boolean(post.isReposts);

          return (
            <GridItem
              key={post.id}
              xs={12}
              sm={6}
              md={4}
              style={{
                display: "flex",
                flexDirection: "column",
                padding: "8px",

                boxSizing: "border-box",
              }}
            >
              <Card style={cardStyle}>
                {/* Header */}
                <div style={headerRowStyle}>
                  <AvatarImage src={post.avatarUrl} company={post.company} />

                  <div
                    style={{
                      flex: 1,
                      minWidth: 0,
                    }}
                  >
                    <div
                      style={{
                        color: "#262626",
                        fontSize: 14,
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {post.company || "Company"}
                    </div>

                    <div
                      style={{
                        marginTop: 2,
                        color: "#8e8e8e",
                        fontSize: 12,
                      }}
                    >
                      Mumbai, India
                    </div>
                  </div>

                  <Tooltip title="More options">
                    <Button justIcon simple color="transparent" type="button">
                      <MoreHoriz style={{ color: "#262626" }} />
                    </Button>
                  </Tooltip>
                </div>

                {/* Product image */}
                <div style={imageWrapperStyle}>
                  {post.image ? (
                    <img
                      src={post.image}
                      alt={`${post.company || "Company"} offer`}
                      style={imageStyle}
                      onLoad={(event) => handleImageLoad(event, post.id)}
                      onError={() => {
                        setRibbonColors((previous) => ({
                          ...previous,
                          [post.id]: "rgba(0, 0, 0, 0.55)",
                        }));
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#777777",
                      }}
                    >
                      Image unavailable
                    </div>
                  )}

                  {/* Top Ribbon */}
                  <div
                    style={{
                      ...ribbonTopStyle,
                      background:
                        ribbonColors[post.id] || "rgba(0, 0, 0, 0.55)",
                    }}
                  >
                    Metal ₹ {post.metal || 0} + Making ₹ {post.making || 0}
                  </div>

                  {/* Bottom Offer */}
                  {isOfferActive && post.offer && (
                    <div style={ribbonBottomStyle}>{post.offer}</div>
                  )}

                  {/* Category */}
                  <div style={ribbonCategoryStyle}>
                    {post.category || ""}
                    <br />
                    {post.sizemm || ""}
                  </div>
                </div>

                {/* Actions */}
                <div style={actionsRowStyle}>
                  <div style={leftActionsStyle}>
                    {/* Like */}
                    <div style={actionWithValueStyle}>
                      <Tooltip
                        title="Like"
                        //    title={post.isLiked ? "Unlike" : "Like"}
                      >
                        <Button
                          justIcon
                          simple
                          color="transparent"
                          type="button"
                          //   onClick={() => toggleLike(post.id)}
                        >
                          <FavoriteBorder style={{ color: "#262626" }} />
                          {/* {post.isLiked ? (
                            <Favorite style={{ color: "#ed4956" }} />
                          ) : (
                            <FavoriteBorder style={{ color: "#262626" }} />
                          )} */}
                        </Button>
                      </Tooltip>

                      <span style={actionCountStyle}>
                        {Number(post.likes) || 0}
                      </span>
                    </div>

                    {/* Comments */}
                    <div style={actionWithValueStyle}>
                      <Tooltip title="Comments">
                        <Button
                          justIcon
                          simple
                          color="transparent"
                          type="button"
                          //   onClick={() => openComments(post.id)}
                        >
                          <ChatBubbleOutline style={{ color: "#262626" }} />
                        </Button>
                      </Tooltip>

                      <span style={actionCountStyle}>
                        {Number(post.comments) || 0}
                      </span>
                    </div>

                    {/* Repost */}
                    <div style={actionWithValueStyle}>
                      <Tooltip
                        title="Reposts"
                        //   title={isReposted ? "Remove repost" : "Repost"}
                      >
                        <Button
                          justIcon
                          simple
                          color="transparent"
                          type="button"
                          //   onClick={() => toggleRepost(post.id)}
                        >
                          <Repeat
                            style={{
                              color: "#262626",
                            }}
                            // style={{
                            //   color: isReposted ? "#1b8f3a" : "#262626",
                            // }}
                          />
                        </Button>
                      </Tooltip>

                      <span
                        style={{
                          ...actionCountStyle,
                          color: "#444444",
                          //   color: isReposted ? "#1b8f3a" : "#444444",
                        }}
                      >
                        {Number(post.reposts) || 0}
                      </span>
                    </div>

                    {/* Share */}
                    <Tooltip title="Share">
                      <Button
                        justIcon
                        simple
                        color="transparent"
                        type="button"
                        // onClick={() => openShare(post)}
                      >
                        <ShareOutlined
                          style={{
                            color: "#262626",
                            fontSize: 21,
                          }}
                        />
                      </Button>
                    </Tooltip>

                    {/* Calls */}
                    <div style={actionWithValueStyle}>
                      <Tooltip title="Call">
                        <Button
                          justIcon
                          simple
                          color="transparent"
                          type="button"
                          //   onClick={() => openCall(post.id)}
                        >
                          <Phone style={{ color: "#262626" }} />
                        </Button>
                      </Tooltip>

                      <span style={actionCountStyle}>
                        {Number(post.calls) || 0}
                      </span>
                    </div>

                    {/* WhatsApp */}
                    <div style={actionWithValueStyle}>
                      <Tooltip title="WhatsApp">
                        <Button
                          justIcon
                          simple
                          color="transparent"
                          type="button"
                          //   onClick={() => openWhatsApp(post)}
                        >
                          <WhatsApp style={{ color: "#25D366" }} />
                        </Button>
                      </Tooltip>

                      <span style={actionCountStyle}>
                        {Number(post.whatsapps) || 0}
                      </span>
                    </div>
                  </div>

                  {/* Save */}
                  <div style={actionWithValueStyle}>
                    <Tooltip
                      title="save"
                      // title={post.isSaved ? "Unsave" : "Save"}
                    >
                      <Button
                        justIcon
                        simple
                        color="transparent"
                        type="button"
                        //   onClick={() => toggleSave(post.id)}
                      >
                        <BookmarkBorder style={{ color: "#262626" }} />
                        {/* {post.isSaved ? (
                          <Bookmark style={{ color: "#262626" }} />
                        ) : (
                          <BookmarkBorder style={{ color: "#262626" }} />
                        )} */}
                      </Button>
                    </Tooltip>
                    <span style={actionCountStyle}>
                      {Number(post.save) || 0}
                    </span>
                  </div>
                </div>

                {/* Caption */}
                <CardBody
                  style={{
                    paddingTop: 10,
                    paddingRight: 16,
                    paddingBottom: 12,
                    paddingLeft: 16,
                    margin: 0,
                    boxSizing: "border-box",
                  }}
                >
                  <div style={captionStyle}>
                    <span
                      style={{
                        fontWeight: 600,
                        marginRight: 5,
                      }}
                    >
                      {post.company || "Company"}
                    </span>

                    {post.description || ""}
                  </div>

                  <span>
                    {post.category || ""}
                    {post.category || post.sizemm ? ", " : ""}
                    {post.sizemm || ""}

                    {post.metalGram !== undefined
                      ? `, Metal Gram ${post.metalGram}`
                      : ""}

                    {post.readyGram !== undefined
                      ? `, Ready Gram ${post.readyGram}`
                      : ""}
                  </span>

                  {post.hashtag && (
                    <div style={hashtagStyle}>{post.hashtag}</div>
                  )}
                </CardBody>
              </Card>
            </GridItem>
          );
        })}
      </GridContainer>
    </div>
  );
}

ViewPosts.propTypes = {
  avatar: PropTypes.bool,
  addButtonProps: PropTypes.object,
  changeButtonProps: PropTypes.object,
  removeButtonProps: PropTypes.object,
};
